/* eslint-disable */

import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";

const STEPS = [
  "Welcome",
  "Overview",
  "Data Protection",
  "Safeguarding",
  "Onboarding",
  "Terms",
  "Confirm",
];

export default function AgreementReviewPage() {
  const { token } = useParams();

  const [loading, setLoading] = useState(true);
  const [signing, setSigning] = useState(false);
  const [error, setError] = useState("");
  const [invite, setInvite] = useState(null);

  const [emailInput, setEmailInput] = useState("");
  const [emailConfirmed, setEmailConfirmed] = useState(false);
  const [emailError, setEmailError] = useState("");

  const [step, setStep] = useState(0);
  const [signedSuccess, setSignedSuccess] = useState(null);

  const [signerName, setSignerName] = useState("");
  const [signerRole, setSignerRole] = useState("School Administrator");
  const [confirmChecked, setConfirmChecked] = useState(false);
const [signerSchoolName, setSignerSchoolName] = useState("");


  useEffect(() => {
    async function validateInvite() {
      try {
        setLoading(true);
        setError("");

        const callable = httpsCallable(functions, "validateAgreementInvite");
        const res = await callable({ token });
        const data = res.data || {};

        if (!data.valid) {
          if (data.reason === "expired") setError("This agreement link has expired.");
          else if (data.reason === "already_signed") setError("This agreement has already been signed.");
          else if (data.reason === "revoked") setError("This agreement invitation was revoked.");
          else setError("Agreement link is invalid.");
          return;
        }

        setInvite(data);
        setSignerName(data.recipientName || "");
      } catch (err) {
        console.error(err);
        setError(err?.message || "Failed to validate agreement invitation.");
      } finally {
        setLoading(false);
      }
    }

    validateInvite();
  }, [token]);

  const progress = useMemo(() => {
    return Math.round(((step + 1) / STEPS.length) * 100);
  }, [step]);

  function handleConfirmEmail(e) {
    e.preventDefault();

    const entered = String(emailInput || "").trim().toLowerCase();
    const expected = String(invite?.recipientEmail || "").trim().toLowerCase();

    if (!entered) {
      setEmailError("Please enter your email address.");
      return;
    }

    if (entered !== expected) {
      setEmailError("This email does not match the invited representative.");
      return;
    }

    setEmailError("");
    setEmailConfirmed(true);
  }

  async function handleSignAgreement() {
    if (!signerName.trim()) {
      alert("Please enter your full name.");
      return;
    }

    if (!signerRole.trim()) {
      alert("Please enter your role.");
      return;
    }

    if (!confirmChecked) {
      alert("Please confirm that you are authorised to sign.");
      return;
    }
if (
  signerSchoolName.trim().toLowerCase() !==
  String(invite?.schoolName || "").trim().toLowerCase()
) {
  alert("School name confirmation does not match.");
  return;
}

    try {
      setSigning(true);

      const signCallable = httpsCallable(functions, "signAgreement");

      const signRes = await signCallable({
        token,
        signerName: signerName.trim(),
        signerEmail: invite?.recipientEmail,
        signerRole: signerRole.trim(),
        confirmationAccepted: true,
      });

      const agreementId = signRes?.data?.agreementId;

      if (!agreementId) {
        throw new Error("Agreement signed, but agreement ID was not returned.");
      }

      const provisionCallable = httpsCallable(functions, "completeAgreementProvisioning");
      const provisionRes = await provisionCallable({ agreementId });

setSignedSuccess({
  agreementId,
  schoolId: provisionRes?.data?.schoolId || "",
  schoolName: provisionRes?.data?.schoolName || invite?.schoolName || "",
});
    } catch (err) {
      console.error(err);
      alert(err?.message || "Failed to complete agreement signing.");
    } finally {
      setSigning(false);
    }
  }

  if (loading) return <CenteredMessage text="Validating agreement..." />;

  if (error) {
    return (
      <Shell>
        <Card>
          <div style={styles.errorCard}>
            <div style={styles.errorTitle}>Agreement unavailable</div>
            <div style={styles.errorText}>{error}</div>
          </div>
        </Card>
      </Shell>
    );
  }

  if (signedSuccess) {
    return (
      <Shell>
        <Card>
          <Header invite={invite} />
          <div style={styles.body}>
            <div style={styles.successPanel}>
              <div style={styles.successIcon}>✓</div>
              <h2 style={styles.successTitle}>Agreement Complete</h2>
              <p style={styles.successText}>
                A signed agreement record has been securely stored. Your school setup is now ready.
              </p>

              <div style={styles.successMeta}>
                <div>
                  <strong>School</strong>
                  <span>{signedSuccess.schoolName}</span>
                </div>
                <div>
                  <strong>Agreement ID</strong>
                  <span>{signedSuccess.agreementId}</span>
                </div>
              </div>

<button
  type="button"
  style={styles.primaryBtn}
  onClick={() => {
    window.location.href = `/activate-school?agreementId=${signedSuccess.agreementId}`;
  }}
>
  Activate Admin Account
</button>
            </div>
          </div>
        </Card>
      </Shell>
    );
  }

  if (!emailConfirmed) {
    return (
      <Shell>
        <Card>
          <Header invite={invite} />
          <div style={styles.body}>
            <div style={styles.confirmCard}>
              <div style={styles.kicker}>Security check</div>
              <h2 style={styles.confirmTitle}>Confirm your email</h2>
              <p style={styles.confirmText}>
                Enter the email address this agreement invitation was sent to.
              </p>

              <form onSubmit={handleConfirmEmail} style={styles.confirmForm}>
                <input
                  value={emailInput}
                  onChange={(e) => setEmailInput(e.target.value)}
                  placeholder="Enter your email address"
                  type="email"
                  style={styles.input}
                />

                {emailError ? <div style={styles.emailError}>{emailError}</div> : null}

                <button type="submit" style={styles.primaryBtn}>
                  Continue
                </button>
              </form>
            </div>
          </div>
        </Card>
      </Shell>
    );
  }

  return (
    <Shell>
      <Card>
        <Header invite={invite} />

        <div style={styles.progressWrap}>
          <div style={styles.stepRow}>
            {STEPS.map((label, index) => (
              <button
                key={label}
                type="button"
                style={{
                  ...styles.stepPill,
                  ...(index === step ? styles.stepPillActive : null),
                  ...(index < step ? styles.stepPillDone : null),
...(index > step ? styles.stepPillLocked : null),
                }}
                onClick={() => {
  if (index <= step) {
    setStep(index);
  }
}}
              >
                {label}
              </button>
            ))}
          </div>
          <div style={styles.progressTrack}>
            <div style={{ ...styles.progressFill, width: `${progress}%` }} />
          </div>
        </div>

        <div style={styles.body}>
          {step === 0 ? (
  <Welcome
    invite={invite}
    onStart={() => setStep(1)}
  />
) : null}
          {step === 1 ? <Overview /> : null}
          {step === 2 ? <DataProtection /> : null}
          {step === 3 ? <Safeguarding /> : null}
          {step === 4 ? <Onboarding /> : null}
          {step === 5 ? <Terms /> : null}
          {step === 6 ? (
<ConfirmSign
  invite={invite}
  signerName={signerName}
  setSignerName={setSignerName}
  signerRole={signerRole}
  setSignerRole={setSignerRole}
  signerSchoolName={signerSchoolName}
  setSignerSchoolName={setSignerSchoolName}
  confirmChecked={confirmChecked}
  setConfirmChecked={setConfirmChecked}
/>
          ) : null}
{step !== 0 ? (
  <div style={styles.footerRow}>
    <button
      type="button"
      style={styles.secondaryBtn}
      disabled={step === 0}
      onClick={() => setStep((s) => Math.max(0, s - 1))}
    >
      Back
    </button>

    {step < STEPS.length - 1 ? (
      <button
        type="button"
        style={styles.primaryBtn}
        onClick={() => setStep((s) => Math.min(STEPS.length - 1, s + 1))}
      >
        Continue
      </button>
    ) : (
      <button
        type="button"
        style={styles.primaryBtn}
        disabled={signing}
        onClick={handleSignAgreement}
      >
        {signing ? "Signing..." : "Accept & Sign"}
      </button>
    )}
  </div>
) : null}
        </div>
      </Card>
    </Shell>
  );
}


function Welcome({ invite, onStart }) {
  return (
    <div style={styles.entryWrap}>
      <div style={styles.entryTop}>
        <img
          src="https://presentplus.uk/presentplus-logo-white.png"
          alt="PresentPlus"
          style={styles.entryLogo}
        />
      </div>

      <div style={styles.entryBody}>
        <div style={styles.entryKicker}>
          PresentPlus School Agreement
        </div>

        <h2 style={styles.entryTitle}>
          Welcome to the PresentPlus onboarding agreement.
        </h2>

        <p style={styles.entryText}>
          This guide will walk you through:
        </p>

        <div style={styles.entryList}>
          <div>• Platform usage</div>
          <div>• Data protection responsibilities</div>
          <div>• Safeguarding model</div>
          <div>• Onboarding process</div>
        </div>

        <div style={styles.entryTime}>
          ⏱ Takes approximately 3–5 minutes
        </div>

        <button
          type="button"
          style={styles.primaryBtn}
          onClick={onStart}
        >
          Start Review
        </button>
      </div>
    </div>
  );
}

function Overview() {
  return (
    <Section title="Platform Overview">
      <List
        items={[
          "PresentPlus is a secure, invite-only platform.",
          "It supports attendance visibility and school updates.",
          "Schools retain control of their data.",
          "Parents cannot self-register without school approval.",
        ]}
      />
      <Highlight>Key Principle: Only school-approved users can access data.</Highlight>
    </Section>
  );
}

function DataProtection() {
  return (
    <Section title="Data Protection and Responsibilities">
      <TwoGrid
        items={[
          ["School Role", "The school remains the Data Controller."],
          ["PresentPlus Role", "PresentPlus acts as the Data Processor."],
          ["Data Used", "Parent contact details, pupil attendance data, reports, and updates."],
          ["Security", "Access controls, encryption, and secure hosting are used to protect data."],
        ]}
      />
      <Highlight>PresentPlus never sells or shares school data.</Highlight>
    </Section>
  );
}

function Safeguarding() {
  return (
    <Section title="Safeguarding and Access Controls">
      <List
        items={[
          "Access is invite-only.",
          "Parents only see child-specific data.",
          "Schools control all visibility.",
          "PresentPlus does not create open parent messaging channels.",
        ]}
      />
      <StrongBox>Parents can only access their own child’s information.</StrongBox>
    </Section>
  );
}

function Onboarding() {
  return (
    <Section title="School Setup Process">
      <List
        items={[
          "Step 1: School uploads parent name, parent email, and child link.",
          "Step 2: Secure parent invitations are sent.",
          "Step 3: Parents activate their accounts.",
          "Step 4: School manages access from the admin dashboard.",
        ]}
      />
      <Highlight>
  Parent accounts can only be created through a secure school invitation. Parents cannot create accounts themselves.
</Highlight>
    </Section>
  );
}

function Terms() {
  return (
    <Section title="Terms and Data Handling">
      <List
        items={[
          "The school can revoke access at any time.",
          "School data remains school-owned.",
          "Upon termination, data may be deleted or returned according to the agreement.",
          "A signed agreement record will be securely stored.",
        ]}
      />
    </Section>
  );
}

function ConfirmSign({
  invite,
  signerName,
  setSignerName,
  signerRole,
  setSignerRole,
  signerSchoolName,
  setSignerSchoolName,
  confirmChecked,
  setConfirmChecked,
}) {
  return (
    <Section title="Confirm & Sign">
      <p>By signing, you confirm that you are authorised to act on behalf of the school.</p>

      <div style={styles.signForm}>
        <label style={styles.label}>
          Full Name
          <input
            value={signerName}
            onChange={(e) => setSignerName(e.target.value)}
            style={styles.input}
          />
        </label>

        <label style={styles.label}>
          Role
          <input
            value={signerRole}
            onChange={(e) => setSignerRole(e.target.value)}
            style={styles.input}
            placeholder="Headteacher / SBM / School Administrator"
          />
        </label>

        <label style={styles.label}>
          School Name
          <input
  value={signerSchoolName}
  onChange={(e) => setSignerSchoolName(e.target.value)}
  style={styles.input}
  placeholder="Enter school name"
/>
        </label>

        <label style={styles.checkConfirm}>
          <input
            type="checkbox"
            checked={confirmChecked}
            onChange={(e) => setConfirmChecked(e.target.checked)}
          />
          <span>
            I confirm that I am authorised to accept this agreement on behalf of the school.
          </span>
        </label>
      </div>
    </Section>
  );
}

function Section({ title, children }) {
  return (
    <div style={styles.sectionCard}>
      <h2 style={styles.sectionTitle}>{title}</h2>
      <div style={styles.sectionContent}>{children}</div>
    </div>
  );
}

function List({ items }) {
  return (
    <div style={styles.list}>
      {items.map((item) => (
        <div key={item} style={styles.listItem}>
          <span style={styles.tick}>✓</span>
          <span>{item}</span>
        </div>
      ))}
    </div>
  );
}

function TwoGrid({ items }) {
  return (
    <div style={styles.twoGrid}>
      {items.map(([title, body]) => (
        <div key={title} style={styles.miniBlock}>
          <strong>{title}</strong>
          <span>{body}</span>
        </div>
      ))}
    </div>
  );
}

function Highlight({ children }) {
  return <div style={styles.highlight}>{children}</div>;
}

function StrongBox({ children }) {
  return <div style={styles.strongBox}>{children}</div>;
}

function CenteredMessage({ text }) {
  return <div style={styles.centered}>{text}</div>;
}

function Shell({ children }) {
  return <div style={styles.shell}>{children}</div>;
}

function Card({ children }) {
  return <div style={styles.card}>{children}</div>;
}

function Header({ invite }) {
  return (
    <div style={styles.header}>
      <div style={styles.headerKicker}>PresentPlus Agreement Portal</div>
      <h1 style={styles.headerTitle}>{invite?.schoolName || "School Agreement"}</h1>
      <p style={styles.headerText}>Secure onboarding agreement for PresentPlus schools.</p>
    </div>
  );
}

const styles = {
  centered: {
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    background: "#f4f7fb",
    fontSize: 18,
    fontWeight: 800,
    color: "#334155",
  },
  shell: {
    minHeight: "100vh",
    background: "#f4f7fb",
    padding: 24,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    width: "100%",
    maxWidth: 980,
    background: "#ffffff",
    borderRadius: 32,
    overflow: "hidden",
    boxShadow: "0 24px 80px rgba(15,23,42,0.12)",
    border: "1px solid #dbe7ff",
  },
  header: {
    background: "linear-gradient(135deg,#12307a 0%,#2563eb 48%,#7c3aed 100%)",
    color: "#fff",
    padding: 40,
  },
  headerKicker: {
    fontSize: 12,
    fontWeight: 900,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    opacity: 0.82,
    marginBottom: 12,
  },
  headerTitle: {
    margin: 0,
    fontSize: 46,
    lineHeight: 1,
    fontWeight: 900,
    letterSpacing: "-0.05em",
  },
  headerText: {
    marginTop: 18,
    marginBottom: 0,
    maxWidth: 650,
    lineHeight: 1.7,
    color: "rgba(255,255,255,0.86)",
  },
  progressWrap: {
    padding: "22px 32px 0",
    display: "grid",
    gap: 14,
  },
  stepRow: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
  },
  stepPill: {
    border: "1px solid #dbe7ff",
    background: "#f8fbff",
    color: "#475569",
    borderRadius: 999,
    padding: "9px 12px",
    fontWeight: 900,
    fontSize: 12,
    cursor: "pointer",
  },
  stepPillActive: {
    background: "#2563eb",
    color: "#ffffff",
    borderColor: "#2563eb",
  },
  stepPillDone: {
    background: "#ecfdf3",
    color: "#166534",
    borderColor: "#bbf7d0",
  },
  progressTrack: {
    height: 9,
    background: "#eef2ff",
    borderRadius: 999,
    overflow: "hidden",
  },
  progressFill: {
    height: "100%",
    background: "linear-gradient(135deg,#2563eb 0%,#7c3aed 100%)",
    borderRadius: 999,
    transition: "width 220ms ease",
  },
  body: {
    padding: 32,
    display: "grid",
    gap: 24,
  },
  confirmCard: {
    borderRadius: 28,
    background: "#f8fbff",
    border: "1px solid #dbeafe",
    padding: 30,
  },
  kicker: {
    fontSize: 12,
    fontWeight: 900,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#2563eb",
    marginBottom: 10,
  },
  confirmTitle: {
    margin: 0,
    fontSize: 34,
    fontWeight: 900,
    letterSpacing: "-0.04em",
    color: "#0f172a",
  },
  confirmText: {
    marginTop: 12,
    color: "#475569",
    lineHeight: 1.7,
    maxWidth: 660,
  },
  confirmForm: {
    marginTop: 22,
    display: "grid",
    gap: 12,
    maxWidth: 520,
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    borderRadius: 18,
    border: "1px solid #cfe0ff",
    background: "#ffffff",
    padding: "15px 16px",
    fontSize: 15,
    color: "#0f172a",
    outline: "none",
  },
  emailError: {
    color: "#b91c1c",
    fontSize: 14,
    fontWeight: 800,
  },
  sectionCard: {
    borderRadius: 28,
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    padding: 32,
  },
  sectionTitle: {
    margin: 0,
    fontSize: 34,
    fontWeight: 950,
    color: "#0f172a",
    letterSpacing: "-0.05em",
  },
  sectionContent: {
    marginTop: 18,
    color: "#475569",
    lineHeight: 1.8,
    fontSize: 15,
  },
  list: {
    display: "grid",
    gap: 12,
  },
  listItem: {
    display: "flex",
    gap: 10,
    alignItems: "flex-start",
    fontWeight: 750,
  },
  tick: {
    width: 24,
    height: 24,
    borderRadius: 999,
    display: "grid",
    placeItems: "center",
    background: "#ecfdf3",
    color: "#166534",
    fontWeight: 950,
    flexShrink: 0,
  },
  highlight: {
    marginTop: 20,
    borderRadius: 20,
    background: "#eff6ff",
    border: "1px solid #bfdbfe",
    color: "#1e40af",
    padding: 18,
    fontWeight: 900,
  },
  strongBox: {
    marginTop: 20,
    borderRadius: 20,
    background: "#fff7ed",
    border: "1px solid #fed7aa",
    color: "#9a3412",
    padding: 18,
    fontWeight: 950,
  },
  twoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: 14,
  },
  miniBlock: {
    borderRadius: 20,
    background: "#f8fbff",
    border: "1px solid #dbeafe",
    padding: 18,
    display: "grid",
    gap: 8,
  },

  stepPillLocked: {
  opacity: 0.45,
  cursor: "not-allowed",
},

  signForm: {
    display: "grid",
    gap: 16,
    marginTop: 18,
  },
  label: {
    display: "grid",
    gap: 8,
    color: "#0f172a",
    fontWeight: 900,
  },
  checkConfirm: {
    display: "flex",
    gap: 12,
    alignItems: "flex-start",
    padding: 18,
    borderRadius: 20,
    background: "#f8fbff",
    border: "1px solid #dbeafe",
    color: "#334155",
    fontWeight: 850,
  },
  footerRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
    alignItems: "center",
  },
  primaryBtn: {
    border: "none",
    borderRadius: 18,
    padding: "16px 26px",
    background: "linear-gradient(135deg,#2563eb 0%,#7c3aed 100%)",
    color: "#ffffff",
    fontSize: 15,
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 18px 40px rgba(79,70,229,0.24)",
  },
  secondaryBtn: {
    border: "1px solid #dbe7ff",
    borderRadius: 18,
    padding: "16px 26px",
    background: "#ffffff",
    color: "#334155",
    fontSize: 15,
    fontWeight: 900,
    cursor: "pointer",
  },
  errorCard: {
    padding: 36,
  },
  errorTitle: {
    fontSize: 32,
    fontWeight: 900,
    color: "#991b1b",
    marginBottom: 14,
  },
  errorText: {
    color: "#475569",
    lineHeight: 1.7,
    fontSize: 16,
  },
  successPanel: {
    borderRadius: 30,
    background: "#f8fbff",
    border: "1px solid #dbeafe",
    padding: 36,
    textAlign: "center",
    display: "grid",
    justifyItems: "center",
    gap: 16,
  },
  successIcon: {
    width: 70,
    height: 70,
    borderRadius: 999,
    background: "#dcfce7",
    color: "#166534",
    display: "grid",
    placeItems: "center",
    fontSize: 34,
    fontWeight: 950,
  },
  successTitle: {
    margin: 0,
    fontSize: 36,
    color: "#0f172a",
    fontWeight: 950,
    letterSpacing: "-0.05em",
  },
  successText: {
    maxWidth: 620,
    color: "#475569",
    lineHeight: 1.7,
    margin: 0,
  },
  successMeta: {
    width: "100%",
    maxWidth: 680,
    display: "grid",
    gap: 12,
    margin: "10px 0",
  },
  successMeta: {
    width: "100%",
    maxWidth: 680,
    display: "grid",
    gap: 12,
    margin: "10px 0",
  },

  entryWrap: {
  display: "grid",
  gap: 30,
},

entryTop: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
},

entryLogo: {
  height: 46,
  objectFit: "contain",
},

entryBody: {
  display: "grid",
  gap: 18,
},

entryKicker: {
  fontSize: 13,
  fontWeight: 900,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
  color: "#2563eb",
},

entryTitle: {
  margin: 0,
  fontSize: 42,
  lineHeight: 1,
  fontWeight: 950,
  letterSpacing: "-0.05em",
  color: "#0f172a",
},

entryText: {
  margin: 0,
  fontSize: 16,
  color: "#475569",
},

entryList: {
  display: "grid",
  gap: 10,
  color: "#334155",
  fontWeight: 700,
  lineHeight: 1.7,
},

entryTime: {
  color: "#64748b",
  fontWeight: 800,
},

nextSteps: {
  marginTop: 20,
  display: "grid",
  gap: 10,
  color: "#334155",
  fontWeight: 700,
},
};